import { useMemo } from "react";
import { geoPath } from "d3-geo";
import { feature } from "topojson-client";
import us from "us-atlas/states-albers-10m.json";

const states = feature(us, us.objects.states).features;
const path = geoPath();
const SHADES = ["#ecfdf5", "#a7f3d0", "#6ee7b7", "#34d399", "#10b981", "#047857"];

export function StateMap({ rows, active, onPick }) {
  const counts = useMemo(() => Object.fromEntries(rows.map((r) => [r.state, r.users])), [rows]);
  const max = Math.max(1, ...rows.filter((r) => r.state !== "Not set").map((r) => r.users));
  const fill = (n) => (!n ? "#f1f5f9" : SHADES[Math.min(SHADES.length - 1, Math.ceil((n / max) * (SHADES.length - 1)))]);
  return (
    <div className="bg-white border border-slate-200 rounded-lg p-4" data-testid="admin-state-map">
      <svg viewBox="0 0 975 610" className="w-full h-auto">
        {states.map((s) => {
          const name = s.properties.name;
          const n = counts[name] || 0;
          return (
            <path key={s.id} d={path(s)} fill={active === name ? "#d97706" : fill(n)} stroke="#fff" strokeWidth={1}
              className="cursor-pointer transition-opacity hover:opacity-80" onClick={() => onPick(active === name ? null : name)} data-testid={`map-state-${name.replace(/ /g, "-").toLowerCase()}`}>
              <title>{`${name}: ${n} user${n === 1 ? "" : "s"}`}</title>
            </path>
          );
        })}
      </svg>
      <div className="flex items-center gap-2 mt-2 text-xs text-slate-500">
        <span>0</span>{SHADES.map((c) => <span key={c} className="h-2.5 w-6 rounded-sm" style={{ background: c }} />)}<span>{max}+ users</span>
        <span className="ml-auto">Click a state to filter</span>
      </div>
    </div>
  );
}
